/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Faq_A5Inputs */

const en_pricing_faq_a5 = /** @type {(inputs: Pricing_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. One-time credit packs are available if you need extra AI actions beyond your monthly allowance. They never expire.`)
};

const de_pricing_faq_a5 = /** @type {(inputs: Pricing_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Einmalige Credit-Pakete sind verfuegbar, wenn Sie zusaetzliche KI-Aktionen ueber Ihr monatliches Kontingent hinaus benoetigen. Sie verfallen nie.`)
};

const fr_pricing_faq_a5 = /** @type {(inputs: Pricing_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscription credits (AI actions) reset monthly and do not carry over. However, purchased credit packs are one-time purchases that never expire.`)
};

const es_pricing_faq_a5 = /** @type {(inputs: Pricing_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscription credits (AI actions) reset monthly and do not carry over. However, purchased credit packs are one-time purchases that never expire.`)
};

const it_pricing_faq_a5 = /** @type {(inputs: Pricing_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscription credits (AI actions) reset monthly and do not carry over. However, purchased credit packs are one-time purchases that never expire.`)
};

const nl_pricing_faq_a5 = /** @type {(inputs: Pricing_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscription credits (AI actions) reset monthly and do not carry over. However, purchased credit packs are one-time purchases that never expire.`)
};

const pl_pricing_faq_a5 = /** @type {(inputs: Pricing_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscription credits (AI actions) reset monthly and do not carry over. However, purchased credit packs are one-time purchases that never expire.`)
};

const fi_pricing_faq_a5 = /** @type {(inputs: Pricing_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscription credits (AI actions) reset monthly and do not carry over. However, purchased credit packs are one-time purchases that never expire.`)
};

const da_pricing_faq_a5 = /** @type {(inputs: Pricing_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscription credits (AI actions) reset monthly and do not carry over. However, purchased credit packs are one-time purchases that never expire.`)
};

const sv_pricing_faq_a5 = /** @type {(inputs: Pricing_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscription credits (AI actions) reset monthly and do not carry over. However, purchased credit packs are one-time purchases that never expire.`)
};

/**
* | output |
* | --- |
* | "Yes. One-time credit packs are available if you need extra AI actions beyond your monthly allowance. They never expire." |
*
* @param {Pricing_Faq_A5Inputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_faq_a5 = /** @type {((inputs?: Pricing_Faq_A5Inputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Faq_A5Inputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_faq_a5(inputs)
	if (locale === "fr") return fr_pricing_faq_a5(inputs)
	if (locale === "es") return es_pricing_faq_a5(inputs)
	if (locale === "it") return it_pricing_faq_a5(inputs)
	if (locale === "nl") return nl_pricing_faq_a5(inputs)
	if (locale === "pl") return pl_pricing_faq_a5(inputs)
	if (locale === "fi") return fi_pricing_faq_a5(inputs)
	if (locale === "da") return da_pricing_faq_a5(inputs)
	if (locale === "sv") return sv_pricing_faq_a5(inputs)
	return en_pricing_faq_a5(inputs)
});